import React from 'react';
import PropTypes from 'prop-types';
import { Card, HeaderCard, TitleCard, ContentCard, Form, SelectLabel, Input, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Widget from '../../../../models/widget';
import Styles from '../resaleSettings.module.css';

function MainSettings({ form, updateForm, organization, event, loading, formErrors }) {
    const { t } = useTranslation();

    const [widgets, loadingWidgets] = Widget.useApiModel(
        {
            organizationId: organization.id,
            query: {
                event__in: event.id,
                usage__in: 'resale'
            }
        },
        [event.id]
    );

    const widgetOptions = React.useMemo(() => {
        if (!widgets) return [];
        return widgets.map(widget => ({
            key: widget.pk,
            text: widget.name,
            value: widget.pk
        }));
    }, [widgets]);

    return (
        <Card>
            <HeaderCard>
                <TitleCard>{t('ticket.resales.settings.main_settings.title')}</TitleCard>
            </HeaderCard>
            <ContentCard>
                <Form>
                    <Form.Field>
                        <Form.Label label={t('ticket.resales.settings.main_settings.default_module')} />
                        <SelectLabel
                            placeholder={t('ticket.resales.settings.main_settings.default_module_placeholder')}
                            options={widgetOptions}
                            value={form.default_resale_widget}
                            onChange={value => updateForm('default_resale_widget', value)}
                            loading={loadingWidgets}
                            disabled={loading}
                        />
                    </Form.Field>

                    <Form.Field>
                        <div className={Styles['label-with-tooltip']}>
                            <Form.Label label={t('ticket.resales.settings.main_settings.host_page')} />
                            <TooltipHelp title={t('ticket.resales.settings.main_settings.host_page_tooltip')} />
                        </div>
                        <Input
                            placeholder={t('ticket.resales.settings.main_settings.host_page_placeholder')}
                            value={form.host_resale_link || ''}
                            onChange={event => updateForm('host_resale_link', event.target.value || null)}
                            disabled={loading}
                        />
                        <Form.FieldErrors errors={[t(formErrors?.host_resale_link)]} />
                    </Form.Field>
                </Form>
            </ContentCard>
        </Card>
    );
}

MainSettings.propTypes = {
    form: PropTypes.object.isRequired,
    updateForm: PropTypes.func.isRequired,
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    submitErrors: PropTypes.object
};

export default MainSettings;
